var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPillOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.34247 8.0003C0.780375 6.43821 0.780374 3.90555 2.34247 2.34345C3.90457 0.781351 6.43723 0.781351 7.99932 2.34345L13.6562 8.0003C15.2183 9.5624 15.2183 12.0951 13.6562 13.6572C12.0941 15.2193 9.56142 15.2193 7.99933 13.6572L2.34247 8.0003ZM3.28528 3.28626C2.24388 4.32765 2.24388 6.0161 3.28528 7.05749L8.94213 12.7143C9.98353 13.7557 11.672 13.7557 12.7134 12.7143C13.7548 11.6729 13.7548 9.98451 12.7134 8.94311L7.05652 3.28626C6.01512 2.24486 4.32668 2.24486 3.28528 3.28626Z",
    fill: "#035B46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8291 6.11422L6.11509 10.8283L5.17228 9.88546L9.88632 5.17142L10.8291 6.11422Z",
    fill: "#035B46"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillOutline);
export default __webpack_public_path__ + "static/media/Pill-Outline.12b3c89073af5831bdcf184979cf04f7.svg";
export { ForwardRef as ReactComponent };